import { render, staticRenderFns } from "./processAccidentEquipment.vue?vue&type=template&id=0802b468"
import script from "./processAccidentEquipment.vue?vue&type=script&lang=js"
export * from "./processAccidentEquipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0802b468')) {
      api.createRecord('0802b468', component.options)
    } else {
      api.reload('0802b468', component.options)
    }
    module.hot.accept("./processAccidentEquipment.vue?vue&type=template&id=0802b468", function () {
      api.rerender('0802b468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/processAccidentEquipment.vue"
export default component.exports